"use client";

import { motion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const tideEntrance = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
export default function TheMissYvonneLegacy() {
  return <section id="the-miss-yvonne-legacy" className="relative bg-background text-foreground py-24 md:py-40 overflow-hidden">
      {}
      <div className="absolute left-8 top-0 bottom-0 w-[1px] bg-border/40 hidden lg:block" />

      <div className="max-w-[1440px] mx-auto px-6 md:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-center">
          
          {}
          <motion.div className="lg:col-span-7 relative" initial="hidden" whileInView="show" viewport={{
          once: true,
          margin: "-100px"
        }} variants={tideEntrance}>
            {}
            <div className="absolute -left-8 top-24 -rotate-90 origin-left font-mono text-xs tracking-widest text-muted-foreground hidden xl:block whitespace-nowrap">
              30° 24' 42" N / 88° 49' 42" W
            </div>

            {}
            <div className="relative border border-border shadow-2xl bg-card p-2 md:p-3">
              <AspectRatio ratio={4 / 3}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/miss_yvonne_vessel_1965.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/miss_yvonne_vessel_1965.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/miss_yvonne_vessel_1965.png-wvc-sizes" alt="The Miss Yvonne cypress fishing vessel built in 1965" className="w-full h-full object-cover" loading="lazy" />
              </AspectRatio>
            </div>
          </motion.div>

          {}
          <motion.div className="lg:col-span-5 flex flex-col justify-center" initial="hidden" whileInView="show" viewport={{
          once: true,
          margin: "-100px"
        }} variants={staggerContainer}>
            {}
            <motion.div variants={tideEntrance} className="flex items-center gap-4 mb-8">
              <span className="font-mono text-sm tracking-[0.25em] text-muted-foreground uppercase">
                01 // The Logbook
              </span>
              <div className="h-[1px] flex-1 bg-border relative">
                 <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1 h-1 bg-primary" />
              </div>
            </motion.div>

            <motion.h2 variants={tideEntrance} className="font-serif text-4xl md:text-5xl lg:text-[clamp(2.5rem,4vw,3.5rem)] font-bold tracking-tight text-foreground leading-[1.1] mb-8">
              A Legacy Built in Cypress
            </motion.h2>

            <motion.div variants={tideEntrance} className="space-y-6 font-sans text-lg text-muted-foreground leading-relaxed mb-12">
              <p>
                Built by hand in 1965 in Ocean Springs, Mississippi, The Miss Yvonne is more than a fishing vessel—she is a testament to enduring craftsmanship and maritime heritage.
              </p>
              <p>
                From the warm waters of the Gulf of Mexico and the Caribbean to navigating the Panama Canal and braving the Pacific Northwest, her hull has weathered decades of hard work. She stands as a symbol of reliability, quality, and the unwavering dedication of those who sail her.
              </p>
            </motion.div>

            <motion.div variants={tideEntrance}>
              <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-foreground hover:text-background font-mono uppercase tracking-widest px-10 py-7 text-sm transition-colors duration-150 rounded-sm shadow-md">
                <Link to="/OurStoryPage">Read Our Story</Link>
              </Button>
            </motion.div>

          </motion.div>
        </div>
      </div>
    </section>;
}